import React, { useEffect, useState } from 'react'
import { postInsertNovedadesAdministrativo, postSelectNovedadesAdministrativa } from '../../../services/PaginaRuta'
import Loading from '../../Loading'
import { HoraActual, fechaActual } from '../../../hooks/UseDate'

const NovedadesAdministrativas = ({setnovedadesAdministra, user}) => {
    const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
    const [dataNovedadesAdmministrativas, setdataNovedadesAdmministrativas]=useState([])
    const [loading, setloading]=useState(false)
    const [errorDescripcion, seterrorDescripcion]=useState('Escribir una novedad')
    const [dataDescripcion, setdataDescripcion]=useState('')

    const handleCancelarClick=()=>{
        setnovedadesAdministra(false)
    }

    useEffect(()=>{
        console.log(usuarioInfo.Nombre,'user data')
        const novedades= {
            "Id_cirugia": user.ProCirCod
        }
        setloading(false)
        postSelectNovedadesAdministrativa(novedades).then((res)=>{
            console.log(res.data,'data novedades')
            setloading(true)
            setdataNovedadesAdmministrativas(res.data)
        })
    },[])

    const handleSubmitGuardarNovedadesAdministrativas=(e)=>{
        e.preventDefault()
        console.log(e.target.codigoCirugia.value, 'codigo cigu')
        const guardarNovedades= {
            "UserRegistrado": usuarioInfo.Nombre,
            "Descripcion_Novedad": dataDescripcion,
            "Fecha_novedad": e.target.fecha.value,
            "Hora_novedad": e.target.hora.value,
            "Id_cirugia": user.ProCirCod
        }
        console.log(guardarNovedades,'guardarNovedades')
        if(errorDescripcion === ''){
            setnovedadesAdministra(false)
            postInsertNovedadesAdministrativo(guardarNovedades).then((res)=>{
                console.log(res.data,'guardado')
            })
        }
    }

    const handleChangeDescripcion=(e)=>{
      console.log(e.target.value)
      if(e.target.value){
        seterrorDescripcion('')
        setdataDescripcion(e.target.value)
      }else{
        seterrorDescripcion('Escribir una descripción')
      }
    }
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-slate-900 bg-opacity-30"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%-3rem)] max-w-5xl my-6 mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#9e56fe]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Novedades Administrativas
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          <div className="flex-auto overflow-y-auto relative p-2">
            <form onSubmit={handleSubmitGuardarNovedadesAdministrativas}>
            <div className="flex py-2 text-left">
              <div className="w-1/2  ">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                Código cirugia
                </label>
                <input
                    //   onChange={searchUserId}
                    //defaultValue={props.userDate[0].ProEmpCod}
                    defaultValue={user.ProCirCod}
                    autoComplete='off'
                    type="text"
                    name="codigoCirugia"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    disabled={true}
                />
              </div>
              <div className="w-1/2  px-2">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                Paciente
                </label>
                <input
                    //   onChange={searchUserId}
                    //defaultValue={props.userDate[0].ProEmpCod}
                    defaultValue={user.MPNOMC}
                    autoComplete='off'
                    type="text"
                    name="codigo"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    disabled={true}
                />
              </div>
            </div>
            <div className="flex py-2 text-left">
              <div className="w-1/2  ">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                Fecha Actual
                </label>
                <input
                    //   onChange={searchUserId}
                    //defaultValue={props.userDate[0].ProEmpCod}
                    defaultValue={fechaActual()}
                    autoComplete='off'
                    type="date"
                    name="fecha"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    disabled={true}
                />
              </div>
              <div className="w-1/2  px-2">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                Hora Actual
                </label>
                <input
                    //   onChange={searchUserId}
                    //defaultValue={props.userDate[0].ProEmpCod}
                    defaultValue={HoraActual()}
                    autoComplete='off'
                    type="text"
                    name="hora"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    disabled={true}
                />
              </div>
            </div>
            <div className=" py-2 text-left">
            <label className="form-label inline-block mb-2 text-gray-900 font-medium">
            Novedad
                </label>
            <textarea
                    //disabled={!reqDispEquiposEspeciales}
                    onChange={handleChangeDescripcion}
                    //value={reqDispEquiposEspecialesUserTextArea}
                    //defaultValue={dataUser.ProObsEE}
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-700  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300 rounded
                        transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    id="exampleFormControlTextarea1"
                    rows="3"
                    placeholder=""
                    ></textarea>
                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                        {errorDescripcion}
                    </label>
            </div>
            
            <div className="flex flex-col">
              <div className="overflow-x-auto ">
                <div className=" inline-block min-w-full  ">
                  <div className="overflow-hidden">
                    <table className="min-w-full text-center">
                      <thead className="border-b bg-gray-200">
                        <tr>
                        <th></th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-4"
                          >
                            Código
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-4"
                          >
                            Usuario
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-4"
                          >
                            Fecha
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-4"
                          >
                            Hora
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-4"
                          >
                            Novedades
                          </th>
                        </tr>
                      </thead>
                      <tbody> 
                        {loading ? (
                          dataNovedadesAdmministrativas.map((item, index) => (
                            <tr className="divide-y divide-slate-700 " key={index}>
                                <td></td>
                                <td className="text-xs text-gray-900 font-medium px-1 py-2  whitespace-pre-wrap">
                                    {item.Id_cirugia}
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-1 py-2  whitespace-pre-wrap">
                                    {item.UserRegistrado}
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-1 py-2  whitespace-pre-wrap">
                                    {item.Fecha_novedad}
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-1 py-2  whitespace-pre-wrap">
                                    {item.Hora_novedad}
                                </td>
                                <td className="text-xs text-gray-900 font-medium px-1 py-2  whitespace-pre-wrap text-left">
                                    {item.Descripcion_Novedad}
                                </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            
                            <td className="text-left">
                              <Loading />
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          
          <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
            <button
              type="button"
              onClick={handleCancelarClick}
              className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Cancelar
            </button>
            <button type="submit"
              className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
              Guardar
            </button>
          </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NovedadesAdministrativas